<template>
  <div>
    <main class="work">
      <main-header negative fixed />
      <sui-loader v-show="fetching" class="general-loader" size="large" active centered inline />
      <filter-country
        v-show="!fetching"
        negative
        class="work__filter"
        @onSelectFilter="filterWorks($event)"
      />
      <grid-works
        :jobs="items"
        v-show="!fetching"
        :fetching="fetching"
        :fadeItems="animateWorks"
        :errorMessage="errorMessage"
      />

      <paginate
        v-model="filters.page"
        v-show="pagination.total > 30 && !fetching && !errorMessage"
        :page-count="pagination.lastPage"
        :page-range="3"
        :margin-pages="2"
        :click-handler="paginate"
        :prev-text="'<'"
        :next-text="'>'"
        :container-class="'pagination'"
        :page-class="'page-item'"
      >
      </paginate>
      <scroll-to />
    </main>

    <main-footer ref="footer" negative v-show="footerVisible" />
  </div>
</template>

<script>
export default {
  name: "work",
  data() {
    return {
      footerVisible: false,
      noResults: false,
      items: [],
      filters: {
        page: 1,
        regional: null,
      },
      fetching: true,
      animateWorks: true,
      errorMessage: "",
      pagination: {
        total: 0,
        perPage: 30,
        lastPage: 0,
      },
    };
  },

  beforeCreate() {
    $("body, html, #app").css("background", "black");
    this.$store.dispatch("setNegativeLayout", true);
  },

  destroyed() {
    $("body, html, #app").removeAttr("style");
    this.$store.dispatch("setNegativeLayout", false);
    this.$hub.$off("repeatRequests");
  },

  mounted() {
    $("body, html, #app").css("background", "black");
    this.$store.dispatch("setNegativeLayout", true);

    setTimeout(() => {
      this.footerVisible = true;
    }, 1200);

    this.$hub.$on("repeatRequests", (language) => {
      this.getJobs(language);
    });

    if (this.$store.state.ui.currentFilter) {
      this.filterWorks({ id: this.$store.state.ui.currentFilter });
    } else {
      this.getJobs(this.$store.state.ui.language);
    }
  },

  methods: {
    getJobs(language, filters) {
      this.fetching = true;
      this.errorMessage = null;

      this.$works
        .get(language, filters)
        .then((resolve) => {
          const { items } = resolve.data;
          this.items = items;
          this.filteredWorks = items;
          this.animateWorks = true;
          this.pagination.lastPage = resolve.paginate.last || 0;
          this.pagination.total = resolve.paginate.total || 0;

          this.animateWorks = true;
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .catch(() => {
          this.errorMessage = this.$t("generals.error");
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    paginate(page) {
      this.getJobs(this.$store.state.ui.language, { page });
      $("body, html").scrollTop(0);
    },

    filterWorks(obj) {
      this.filters.regional = obj.id;
      this.filters.page = 1;

      this.getJobs(this.$store.state.ui.language, this.filters);
    },
  },
};
</script>

<style lang="scss">
.work {
  background: black;
  height: 100%;
  padding-top: 60px;
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  margin-bottom: 300px;
  z-index: 2;

  &__filter {
    margin: 120px 0 50px;
  }

  .pagination {
    a {
      color: white !important;

      &:hover {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }

    li {
      &.active {
        a {
          color: rgba(255, 255, 255, 0.5) !important;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .work {
    &__filter {
      margin: 80px 0;
    }
  }
}
</style>
